import mongoose from 'mongoose';
import schema, { IAmenityDocument } from '../schemas/amenities';

const Amenities = (mongoose.models.Amenities ||
  mongoose.model<IAmenityDocument>('Amenities', schema)) as mongoose.Model<IAmenityDocument>;

export default Amenities;
